<div class="policy-target" [ngbTooltip]="tooltip" placement="top">
    <ng-template ngFor let-targetIcon [ngForOf]="targetIcons">
        <mon-icon-circle [color]="iconColors[color]"
                     [icon]="options[targetIcon]"
                     [monAriaText]="'[[target]]' | translate:'':{targetIcon}"
                     *ngIf="!passed && !isMobileCheck && target===targetIcon">
        </mon-icon-circle>
    </ng-template>
    <mon-icon-circle [color]="iconColors.passed"
                 [monIconDirect]="'faCheck'"
                 [monAriaText]="'Passed' | translate"
                 *ngIf="passed">
    </mon-icon-circle>


    <div class="icon-circle" [class]="{ 'text-wcag-a' : color === 'wcag-a' }" *ngIf="isMobileCheck && !passed">
        <mon-icon class="icon"
                  [icon]="['ACCESSIBILITY_CHECKS', 'MOBILE_WARNING']"
                  *ngIf="target === 'warning'">
        </mon-icon>
        <mon-icon class="icon"
                  [icon]="['ACCESSIBILITY_CHECKS', 'MOBILE_ERROR']"
                  *ngIf="target === 'error'">
        </mon-icon>
        <mon-icon class="icon"
                  [icon]="['ACCESSIBILITY_CHECKS', 'MOBILE_REVIEW']"
                  *ngIf="target === 'review'">
        </mon-icon>
    </div>
</div>
